import { useState }  from 'react';
import Header from './Components/Header.js';
import Home from './Components/Home.js';
import LatestJobs from './Components/LatestJobs.js';
import Admitcard from './Components/Admitcard.js';
import Results from './Components/Results.js';
import { Route, Routes, useNavigate } from 'react-router-dom'; 
import Admitcardfloatcomponent from './Components/Admitcardfloatcomponent.js';
import ResultDownloadFloatingComp from './Components/ResultDownloadFloatingComp.js'
import ShowpostallDetails from './Components/ShowpostallDetails.js';
import api from './Components/api.js'; 

let Appjob= ()=>{
  let navigate = useNavigate();

   let getallvacancydetails =async(e)=>{
       try {
            let singlepostdocreqid = new FormData();
            singlepostdocreqid.append("singlepostid", e.postid);
            const res = await api.post('getsinglepostdocreq.php', singlepostdocreqid);
             const resp = await api.post('getmultipostdatabypostid.php', singlepostdocreqid);
            let multipostdocreq = new FormData();
            multipostdocreq.append("multipostid", resp.data.data[0].multipostid)
            const response = await api.post('getmultipostdocreq.php',multipostdocreq);
            let Alldata=[e, res.data.data??"", resp.data.data??"", response.data.data??""];
           setallvacancydetails(Alldata);
            navigate("./VacancyDetails");
        
        } catch (error) {
            console.log(error.data);
        }  
  }
  // let [getclickedonvacancyfunction, setgetclickedonvacancyfunction] = useState(null);
  let getjobclickhandelfun=(e)=>{
    getallvacancydetails(e);
  }
  let [senddatatoappjobscomp, setsenddatatoappjobscomp]= useState('');
  let getallapidata = (rec)=>{
    setsenddatatoappjobscomp(rec)
  }
  let [senddatatoadmitcarddownloadcomponent, setsenddatatoadmitcarddownloadcomponent ] = useState('');
  let getadmitcarddownloaddatafromhome =(admitdata)=>{
    setsenddatatoadmitcarddownloadcomponent(admitdata);
    
    
  }

 

  let [resultdownload, setresultdownlaod] = useState('')
  
  let getresultdata = (recresultdata)=>{
    setresultdownlaod(recresultdata);
  }
  let [allvacancydetails, setallvacancydetails] =useState(['']);

 
  return(
    <div style={{width:"100%"}}>
      <Header/>
      <Routes>
      <Route path='/' element={<Home getresultdata={getresultdata} getadmitcarddownloaddata={getadmitcarddownloaddatafromhome} getallapidata={getallapidata} getallvacancydetails={getallvacancydetails} getclickjobfun={getjobclickhandelfun} />}/>
      <Route path='LatestJobs' element={<LatestJobs singledata={senddatatoappjobscomp} getclickedonvacancyfunction={getjobclickhandelfun} />}/>
      <Route path='Admitcard' element={<Admitcard singledata={senddatatoappjobscomp} callfunctionadmitcard={getadmitcarddownloaddatafromhome} />}/>
      <Route path='Results' element={<Results singledata={senddatatoappjobscomp} resultfuncall={getresultdata}/>}/>

      <Route path='AdmitcardDownload' element={<Admitcardfloatcomponent admitcarddata = {senddatatoadmitcarddownloadcomponent}/>}/>
      <Route path='ResultDownload' element={<ResultDownloadFloatingComp ResultDownloaddata={resultdownload} />}/>
      <Route path='VacancyDetails' element={<ShowpostallDetails latestdet={allvacancydetails}/>}/>
      </Routes>
      
      
      
      
    </div>
  );

}

export default Appjob;